import * as moment from "moment";

export function formatRupiah(value: number): string {
  if (value == null) return '';
  return 'Rp' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function formatDate(date: string | Date): string {
  return moment(date).format('D MMMM YYYY');
}

export function formatDateTime(date: string | Date): string {
  return moment(date).format('D MMMM YYYY, HH:mm');
}